export const projectTemplates = [
  {
    id: "1",
    name: "Simulation App Template",
    description:
      "Template for an app for running simulations. Inputs for parameters, a run/stop button, a progress bar and a simple structure to run your simulation code. The app is using the Panel framework.",
    image:
      "https://images.unsplash.com/photo-1687593883595-6b678fc5c413?q=80&w=3687&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?auto=format&q=75&fit=crop&w=600",
    githubLink: "https://github.com/numerous-com/panel-simulation-app-template"
  },
  {
    id: "selector-app-template",
    name: "Selector App Template",
    description:
      "Template for an app for selecting a product. Inputs for filtering and a list of products to select from. The app is using the Panel framework.",
    image:
      "https://images.unsplash.com/photo-1610465299996-30f240ac2b1c?auto=format&q=75&fit=crop&w=600",
    githubLink: "https://github.com/numerous-com/panel-selector-app-template"
  },
  {
    id: "dashboard-app-template",
    name: "Dashboard App Template",
    description:
      "Template for an app for displaying a dashboard. The app is using the Panel framework with Perspective.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?auto=format&q=75&fit=crop&w=600",
    githubLink: "https://github.com/numerous-com/panel-dashboard-app-template"
  },
  {
    id: "use-public-repo",
    name: "Public Github repository",
    description: "Use your public repository link.",
    image:
      "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
    githubLink: ""
  },
  {
    id: "use-cli",
    name: "Use CLI",
    description: "Use your own project to deploy using CLI.",
    image: "",
    githubLink: ""
  },
  {
    id: "local-project",
    name: "Local Project",
    description: "Use your own project stored locally on your computer.",
    image: "",
    githubLink: ""
  }
];
